import type {
  BackendFundReferenceDto,
  BackendReportingFundReferenceDto,
  BackendShareClassReferenceDto,
  ReferenceDataItem,
} from '@/features/reference-data/reference-data.def.ts';

export const mapFundReferenceItem = (dto: BackendFundReferenceDto): ReferenceDataItem => ({
  id: dto.id,
  displayName: dto.displayName,
  isActive: dto.isActive,
  displayAliases: dto.displayAliases,
  reportingFundId: dto.reportingFundId,
});

export const mapReportingFundReferenceItem = (
  dto: BackendReportingFundReferenceDto,
): BackendReportingFundReferenceDto => ({
  id: dto.id,
  displayName: dto.displayName,
  isActive: dto.isActive,
});

export const mapShareClassReferenceItem = (
  dto: BackendShareClassReferenceDto,
): ReferenceDataItem => ({
  id: dto.id,
  displayName: dto.displayName,
  isActive: dto.isActive,
});
